import React from "react";
import DHSplashScreen from "../../component/DHSplashScreen";
import DefaultButton from "../../component/DefaultButton";
import Footer from "../../component/Footer";
import Header from "../../component/Header";
import DH_Logo from "../../images/dh-logo-min-1.svg";
import after_login from "../../images/after_login.svg";
import { DECCAN_MOBILE_TAB } from "../../contant";

export default function DeccanSuccessfulLoginPage({
  tabDetail,
  formData,
  handleInputChange,
  isInputFocused,
  setIsInputFocused,
  updateProfileMetaDataForDeccan,
  isContinueBtnDisabled,
  callbackUrl,
  navigate,
  emailRequired,
}) {
  return (
    <div className="lg:h-full xxxl:h-screen xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
      <div className="flex flex-row w-full text-center justify-center lg:pt-8 px-10 md:p-1 xxxl:pt-0 sm:min-h-mobile">
        <DHSplashScreen logoImage={DH_Logo} />
        <div className="w-1/2 shadow-md bg-white ml-2 rounded-2xl sm:w-full sm:ml-0 sm:flex sm:flex-col">
          <Header headerImage={after_login} />
          <p className="text-gray-700 font-bold mt-[72px] text-2xl mb-6">
            Successfully Verified
          </p>
          <div className="mb-8">
            <p className="text-gray-700 text-base mt-4 font-notoSerif leading-7">
              Your{" "}
              {tabDetail === DECCAN_MOBILE_TAB ? "Mobile number" : "Email ID"}{" "}
              has been successfully verified.
            </p>
          </div>
          <fieldset className="contents" disabled={isContinueBtnDisabled}>
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="w-full flex justify-center lg:px-10 md:px-8 xs:px-12 mb-6">
                <div className="w-1/2 flex items-start lg:w-full md:w-full sm:w-full xs:w-full gap-[8px] self-stretch">
                  <label
                    className="checkbox-container mt-1"
                    htmlFor="receiveMarketingAndPromitionalEmail"
                  >
                    <input
                      type="checkbox"
                      id="receiveMarketingAndPromitionalEmail"
                      name="receiveMarketingAndPromitionalEmail"
                      checked={formData.receiveMarketingAndPromitionalEmail}
                      onChange={handleInputChange}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span className="checkbox-label text-gray-700 text-sm leading-6 text-left">
                    I agree to receive marketing and promotional communications.
                  </span>
                </div>
              </div>
              {!(tabDetail === DECCAN_MOBILE_TAB) ? (
                <div className="w-full flex justify-center mt-2 lg:px-10 md:px-8 xs:px-12 mb-6">
                  <div className="w-1/2 flex items-center lg:w-full md:w-full sm:w-full xs:w-full gap-[8px] self-stretch">
                    <label
                      className="checkbox-container"
                      htmlFor="dhNewsLetterTopNewsOfTheDay"
                    >
                      <input
                        type="checkbox"
                        id="dhNewsLetterTopNewsOfTheDay"
                        name="dhNewsLetterTopNewsOfTheDay"
                        checked={formData.dhNewsLetterTopNewsOfTheDay}
                        onChange={handleInputChange}
                      />
                      <span className="checkmark"></span>
                    </label>
                    <span className="text-left checkbox-label text-gray-700 text-sm leading-6">
                      Sign me up for  ‘Top News of the Day’ Newsletter
                    </span>
                  </div>
                </div>
              ) : (
                <div className="mt-32"></div>
              )}
              <div
                className={`drop-shadow-div mt-4 ${
                  tabDetail === DECCAN_MOBILE_TAB ? "" : "!mt-32"
                }`}
              >
                <div className="w-full mb-4 mt-4 lg:px-9 md:px-10 sm:px-10 xs:px-4">
                  <DefaultButton
                    label={
                      tabDetail === DECCAN_MOBILE_TAB ? "Continue" : "Finish"
                    }
                    onClick={() => {
                      setIsInputFocused(false);
                      updateProfileMetaDataForDeccan();
                    }}
                    className={
                      "w-[55%] lg:w-full md:w-full sm:w-full xs:w-full mt-2"
                    }
                    disabled={isContinueBtnDisabled}
                    type={"submit"}
                  />
                </div>
              </div>
            </form>
          </fieldset>
          <Footer
            footerLable={"Your Login, Simplified"}
            className="sm:mt-auto"
          />
        </div>
      </div>
    </div>
  );
}
